import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class LocalPinDbTableDefinition extends DbTableDefinition {
    tableName = 'local_pins';
    tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
       databag LONGTEXT,
       extfileid BIGINT(20) NOT NULL,
       pintypeid BIGINT(20) NOT NULL,
       locationx DOUBLE NOT NULL,
       locationy DOUBLE NOT NULL,
       page INTEGER NOT NULL,
       name TEXT NOT NULL,
       description TEXT NOT NULL,
       color VARCHAR(7) NOT NULL,
       entitycreatedtstamp INTEGER NOT NULL,
       createdby TEXT NOT NULL,
       entitycreateddevicetoken BIGINT(20),
       entitycreatedlocaldeviceid BIGINT(20)
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}